import { FileUpload } from "primereact/fileupload";
import ApiBaseURLProps from "./apiBaseURL";
import { useEffect, useRef, useState } from "react";
import CaptureImage from "../kyc/CaptureImage";
import { Button } from "primereact/button";
import { Image } from "primereact/image";
import { useToast } from "./Toast";
import fileUploadService from "../service/fileUploadService";
import { getTObjectValue, getTValue } from "../other/label";
import { useTranslation } from "react-i18next";
import CustomImage from "../other/Image";

const requiredImageType = ['image/png', 'image/jpg', 'image/jpeg'];

const type = {
  userPhoto: (fileSize) => ({
    hint: (<span style={{ fontSize: 13, textAlign: "center" }}>
      Upload your passport size photo (PNG/JPG upto {fileSize || 1024} KB accepted) <br />
      or use webcam for capturing photo
    </span>),
    hintNep: (<span style={{ fontSize: 13, textAlign: "center" }}>
      हालसालै खिचेको फोटो(PNG/JPG 1MB सम्म) <br />
      वा वेबक्यामबाट फोटो लीनुहोस्
    </span>),
    hintPosition: 'up',
    fileType: 'I',
    defaultThumbnailImage: "/photo.png",
    showWebcamButton: true,
    width: 138,
    height: 177
  }),
  map: {
    hint: (<span style={{ fontSize: 13 }}>
      Upload Map (PNG/JPG upto 1MB accepted)
    </span>),
    hintPosition: 'up',
    fileType: 'I',
    defaultThumbnailImage: "/map_location.svg",
    width: 400,
    height: 'none',
    defaultWidth: 200,
    defaultHeight: 200
  }
};

const FileUploadComponent = (props) => {
  const { t, i18n } = useTranslation();
  const document = props.data || {};
  const toast = useToast();
  const [showWebcam, setShowWebcam] = useState(false);
  const [rloading, setRloading] = useState(false);
  let typeFunctionResult = {};
  if (typeof type[props.type] === 'function' && document.fileSize) {
    typeFunctionResult = type[props.type](document.fileSize);
  }
  const documentDetail = {
    fileType: document.fileType,
    showWebcamButton: props.showWebcamButton,
    defaultThumbnailImage: props.defaultThumbnailImage,
    hintPosition: props.hintPosition || 'down',
    hint: (<span style={{ fontSize: 13 }}>
      ({document.fileType === 'P' ? 'PDF' : 'PNG/JPG'} upto {document.fileSize || 1024} KB accepted)
    </span>),
    hintNep: (<span style={{ fontSize: 13 }}>
      ({document.fileType === 'P' ? 'PDF' : 'PNG/JPG'} {document.fileSize || 1024} KB सम्म)
    </span>),
    thumbnail: true,

    ...(typeFunctionResult || {}),
    // ...(type[props.type] && document.fileSize && type[props.type](document.fileSize) || {})
    // ...(type[props.type] ? type[props.type] : {}),
  };
  documentDetail.hint = getTValue(i18n, documentDetail.hint, documentDetail.hintNep);

  return (
    <div
      style={{
        display: "flex",
        placeItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      {documentDetail.thumbnail && <CustomImage
        preview={documentDetail.fileType !== 'P'}
        src={
          document.fileId
            ? documentDetail.fileType !== 'P'
              ? ApiBaseURLProps.apiBaseURL + "/file/" + document.fileId
              : "/unknown_file_icon.png"
            : documentDetail.defaultThumbnailImage || "/file_icon.png"
        }
        alt="Image Text"
        width={document.fileId ? documentDetail.width || 100 : documentDetail.defaultWidth || documentDetail.width || 100}
        height={document.fileId ? documentDetail.height || 100 : documentDetail.defaultHeight || documentDetail.height || 100}
      />}
      {documentDetail.hintPosition === 'up' && documentDetail.hint}
      <span>
        {document.fileId
          ? <a
            href={ApiBaseURLProps.apiBaseURL + "/file/" + document.fileId}
            target="_blank">
            {document.fileName}
          </a>
          : 'No file chosen'}
      </span>
      <div id="file-upload-div" style={{ display: 'flex', flexDirection: 'row' }}>
        <FileUpload
          mode="basic"
          name="fileUpload"
          auto
          accept={documentDetail.fileType === 'P' ? 'application/pdf' : "image/*"}
          customUpload={true}
          uploadHandler={(fup) => {

            if (fup.files && fup.files[0] && document) {
              const file = fup.files[0];
              const fileName = file.name;

              // Validate file name for multiple periods
              if ((fileName.match(/\./g) || []).length > 1) {
                toast.error("Invalid file name", "File name should not contain more than one '.'");
              } else if (!file.type) {
                toast.error("Invalid file type");
              } else if (file.size >= ((document && document.fileSize) || 1024) * 1024) {
                toast.error("File size large", `File size must be less than ${(document && document.fileSize) || 1024} KB`);
              } else if (file.size <= ((document && document.minFileSize) || 1) * 1024) {
                toast.error("File size small", `File size must be greater than ${(document && document.minFileSize) || 1} KB`);
              } else if (documentDetail.fileType === 'P' && 'application/pdf' !== file.type) {
                toast.error("Invalid file type", 'Only PDF file allowed');
              } else if (documentDetail.fileType !== 'P' && !requiredImageType.includes(file.type)) {
                toast.error("Invalid Image type", 'Only JPG and PNG Image file allowed');
              } else {
                setRloading(true);
                fileUploadService.uploadFile(file, file.fileName)
                  .then(response => {
                    toast.success("Successful", "File Upload Success");
                    props.onUpload(response.data);
                  }).catch(e => {
                    toast.error("Error", "File Upload Failed");
                  }).finally(() => {
                    setRloading(false);
                  });
              }
            } else toast.error("Invalid file");
            fup.options.clear();
          }}
          disabled={rloading}
          maxFileSize={((document && document.fileSize) || 1024) * 1024}
          onValidationFail={(e) => {
            toast.error(
              "Invalid File",
              e.size > ((document && document.fileSize) || 1024) * 1024
                ? `File size must be less than ${(document && document.fileSize) || 1024} KB`
                : "")
          }}
          onError={(e) => {
            setRloading(false);
            toast.error("Error Message", "File Not Uploaded")
          }}
          onUpload={(data) => {
          }}
        />
        {documentDetail.showWebcamButton && <Button style={{ width: 30, borderRadius: 0 }}
          disabled={rloading} icon={rloading ? "pi pi-spin pi-spinner" : 'pi pi-camera'} onClick={() => setShowWebcam(true)} />}
        {!documentDetail.showWebcamButton && rloading && <i className="pi pi-spin pi-spinner" style={{ height: '1em', margin: '0.8em' }} />}
      </div>
      {documentDetail.hintPosition === 'down' && documentDetail.hint}
      {showWebcam && <CaptureImage docType={documentDetail.fileType} visible={showWebcam} onHide={() => setShowWebcam(false)} onUpload={props.onUpload} />}
    </div>
  );
};
export default FileUploadComponent;
